import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.company-registration-success', {
        url: '/companyRegistration-success',
        templateUrl: require('./company-registration-success.html'),
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/company-registration-success/company-registration-success.state.js